// ---------------------------------------------------------------------------
// SeasonRecapWatcher — global (AppFrame), irmão do `LeagueWeekRecapWatcher`.
// Abre o cartão de fechamento da temporada quando o servidor marcou
// `users.seasonRecapPending` e este aparelho ainda não o dispensou.
// ---------------------------------------------------------------------------

import { lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../hooks/useAuth";
import { useSuppressCelebrations } from "../../../gamification/utils/celebrationGate";
import { useSeasonRecap } from "../../hooks/useSeasonRecap";

// Lazy: o cartão abre uma vez por temporada; fora do entry (17/09).
const SeasonRecapModal = lazy(() =>
  import("./SeasonRecapModal").then((m) => ({ default: m.SeasonRecapModal })),
);

export function SeasonRecapWatcher() {
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const pending = (profile as { seasonRecapPending?: string | null } | null | undefined)?.seasonRecapPending ?? null;
  const { recap, dismiss } = useSeasonRecap(user?.uid ?? null, pending);

  useSuppressCelebrations(!!recap, "league-recap");

  if (!recap || !user) return null;

  return (
    <Suspense fallback={null}>
      <SeasonRecapModal
        recap={recap}
        onClose={dismiss}
        onGoToSeason={() => navigate("/leagues?tab=season")}
        onGoToHall={() => navigate("/leagues/hall")}
        username={profile?.username ?? profile?.displayName ?? "leitor"}
        themeId={profile?.themeId ?? profile?.themePreference}
      />
    </Suspense>
  );
}
